import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { formatCurrency, formatTimestamp } from '../../qCockpit/components/SharedFrames';
import { shellTokens } from '../../shell/theme/shellTheme';
import ParamChips from './ParamChips';

const pnlColor = (value) => {
    if (value > 0) return shellTokens.success;
    if (value < 0) return shellTokens.error;
    return shellTokens.text;
};

const PositionRow = ({ position }) => {
    const isOpen = position.status === 'open';

    return (
        <TableRow hover>
            <TableCell sx={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                {position.strategyLabel || position.strategyId}
            </TableCell>
            <TableCell sx={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                {position.clientAlias || position.clientId}
            </TableCell>
            <TableCell sx={{ fontFamily: shellTokens.monoFamily, fontSize: '0.82rem' }}>
                {position.symbol || '—'}
            </TableCell>
            <TableCell sx={{ fontFamily: shellTokens.monoFamily, fontSize: '0.82rem', minWidth: 120 }}>
                <Typography sx={{ fontSize: 'inherit', fontFamily: 'inherit', lineHeight: 1.35 }}>
                    {formatTimestamp(position.entryAt)}
                </Typography>
                <Typography sx={{ fontSize: '0.74rem', color: shellTokens.muted, fontFamily: 'inherit' }}>
                    {position.entryPrice != null ? formatCurrency(position.entryPrice) : '—'}
                </Typography>
            </TableCell>
            <TableCell sx={{ fontFamily: shellTokens.monoFamily, fontSize: '0.82rem', minWidth: 120 }}>
                {isOpen ? (
                    <Typography sx={{ fontSize: '0.74rem', color: shellTokens.muted }}>—</Typography>
                ) : (
                    <>
                        <Typography sx={{ fontSize: 'inherit', fontFamily: 'inherit', lineHeight: 1.35 }}>
                            {formatTimestamp(position.exitAt)}
                        </Typography>
                        <Typography sx={{ fontSize: '0.74rem', color: shellTokens.muted, fontFamily: 'inherit' }}>
                            {position.exitPrice != null ? formatCurrency(position.exitPrice) : '—'}
                        </Typography>
                    </>
                )}
            </TableCell>
            <TableCell sx={{ minWidth: 110 }}>
                <Typography
                    sx={{
                        fontFamily: shellTokens.monoFamily,
                        fontWeight: 700,
                        fontSize: '0.82rem',
                        color: pnlColor(position.netPnl),
                        lineHeight: 1.35,
                    }}
                >
                    {formatCurrency(position.netPnl)}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: shellTokens.monoFamily,
                        fontSize: '0.72rem',
                        color: shellTokens.muted,
                        lineHeight: 1.35,
                    }}
                >
                    Gross {formatCurrency(position.grossPnl)}
                </Typography>
            </TableCell>
            <TableCell sx={{ minWidth: 160 }}>
                <ParamChips params={position.params} />
            </TableCell>
            <TableCell sx={{ fontSize: '0.82rem', textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                <Box
                    component="span"
                    sx={{
                        color: isOpen ? shellTokens.success : shellTokens.muted,
                        fontWeight: isOpen ? 700 : 500,
                    }}
                >
                    {position.status}
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default PositionRow;
